// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"editUser_parentContainer__1EqY0","pageTitle":"editUser_pageTitle__iyEru","form":"editUser_form__esal0","updateButton":"editUser_updateButton__1u2nA"};